import { FC, MouseEvent } from 'react';

import { ImageComponent } from '@/components/Image';

import { ScPlayButton } from './styled';

const DEFAULT_BUTTON_SIZE = 52;

interface IPlayButtonProps {
  href: string;
  size?: number;
  onClick?: (event: MouseEvent) => void;
}

export const PlayButton: FC<IPlayButtonProps> = ({
  href,
  size = DEFAULT_BUTTON_SIZE,
  onClick,
}) => {
  return (
    <ScPlayButton href={href} size={size} onClick={onClick}>
      <ImageComponent
        src="/game/play-button-icon.svg"
        width={24}
        height={24}
        alt="play button icon"
      />
    </ScPlayButton>
  );
};
